const useWindowReload = () => {
  return () => window.location.reload();
};

export { useWindowReload };
